import appConfig from "../config";

const { put_endpoint } = appConfig;


const genPOST = (data) => {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      // 'Content-Type': 'application/x-www-form-urlencoded',
    },
    body: JSON.stringify(data),
  };
};

const fetchT = (url, options, timeout = 7000) => {
  return Promise.race([
      fetch(url, options),
      new Promise((_, reject) =>
          setTimeout(() => reject(new Error('timeout')), timeout)
      )
  ]);
}

// export sls "serverless" helper
export default (loadState) => {
  return {
    verify: async (phone, code, activeKey, ownerKey) => {
      try {
        const fetchResponse = await fetchT(
          `${put_endpoint}/verify`,
          genPOST({phone, code, activeKey, ownerKey})
        );
        const data = await fetchResponse.json();
        return data.accountName;
      } catch (e) {
        console.log("could not verify account");
        return false;
      }
    },
  };
};
